import { Input } from "antd";
import React, { useState, useRef, useCallback, useEffect } from "react";
import { LuSearch } from "react-icons/lu";

export const DEBOUNCE_TIME_DEFAULT = 500;

function DebounceInput(props) {
  const {
    placeholder,
    value,
    className,
    type,
    name,
    id,
    required,
    onChange,
    defaultValue,
    reference,
    label,
    labelClasses,
    allowClear,
    suffix = <LuSearch className="icon-color" />,
    showSuffix = true, // Set false to hide the default search-icon suffix
    debounceTime = DEBOUNCE_TIME_DEFAULT, // Default debounce time
    style = {},
    inputWidthClass,
    disabled,
    prefix,
    maxLength,
    size,
    onKeyDown,
    addonAfter,
  } = props;

  const [debouncedValue, setDebouncedValue] = useState(value ?? defaultValue);
  const debounceTimeout = useRef(null);

  useEffect(() => {
    setDebouncedValue(value ?? defaultValue);
  }, [value, defaultValue]);

  const handleChange = useCallback(
    e => {
      const newValue = e.target.value;
      setDebouncedValue(newValue);

      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        if (onChange) {
          onChange(newValue); // Return only the debounced value
        }
      }, debounceTime);
    },
    [onChange, debounceTime]
  );

  return (
    <>
      {label && (
        <label className={labelClasses}>
          {label}
          {required && <span className="text-red-500"> *</span>}
        </label>
      )}
      <Input
        className={`${inputWidthClass || "w-full"} ${className}`}
        type={type}
        name={name}
        id={id}
        required={required}
        placeholder={placeholder}
        value={debouncedValue}
        onChange={handleChange}
        defaultValue={defaultValue}
        ref={reference}
        allowClear={allowClear}
        suffix={showSuffix ? suffix : null}
        disabled={disabled}
        style={style}
        prefix={prefix}
        maxLength={maxLength}
        size={size}
        onKeyDown={onKeyDown}
        addonAfter={addonAfter}
      />
    </>
  );
}

export default DebounceInput;
